import React from 'react';
import { useDispatch } from 'react-redux';
import withTokenInterceptor from '../../../hoc/withTokenInterceptor/withTokenInterceptor';

import { initializePageAction } from '../../../store/theme.actions';
import { ValoresAPagarPelaABE } from './ValoresAPagarPelaABE';

function ValoresAPagarPelaABEPage() {
  const dispatch = useDispatch();

  dispatch(initializePageAction('Valores A Pagar Pela ABE'));
  return (
    <ValoresAPagarPelaABE />
  );
}

export default withTokenInterceptor(ValoresAPagarPelaABEPage);
